"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const messages_1 = __importDefault(require("../../lib/messages"));
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const styles_1 = require("./styles");
/**
 * Renders the Provider Clinical Interests component.
 *
 * @param {ProviderClinicalInterestsProps} props - The component props.
 * @returns {React.ReactElement} The rendered Provider Clinical Interests component.
 */
const ProviderClinicalInterests = ({ provider, track }) => {
    var _a;
    // do not render if data not present
    if (!provider.clinical_interests ||
        provider.clinical_interests.length === 0) {
        return null;
    }
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-clinical-interests-section", track: track },
        react_1.default.createElement(styles_1.ClinicalInterestsTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.providerClinicalInterestsTitle))),
        react_1.default.createElement(styles_1.ClinicalInterestsContentText, { content: (_a = provider.clinical_interests) !== null && _a !== void 0 ? _a : '', "data-testid": 'clinical-interests-content', disableDefaultMatchers: true, itemProp: "description" })));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)(ProviderClinicalInterests);
//# sourceMappingURL=provider-clinical-interests.js.map